(function() {
    'use strict';

    angular
        .module('app.directive')
        .directive('taiMyTrainingRepairProject', taiMyTrainingRepairProject);

    function taiMyTrainingRepairProject() {
        var directive = {
            bindToController: true,
            controller: taiMyTrainingRepairProjectController,
            controllerAs: 'vm',
            restrict: 'E',
            templateUrl: 'controller/tsun/training/myTraining/taiMyTraining.repairProject.html',
            scope: {
                isFocus: '=',
            }
        };
        return directive;
    }

    /* @ngInject */
    function taiMyTrainingRepairProjectController(trainingInnerService, modalService, $q, $scope) {
        var vm = this;
        vm.directToCourse = directToCourse;
        //==Main==
        init();
        //========
        function init() {
            vm.isMobile = modalService.isMobile();
            vm.openDetail = openDetail;
            vm.setPercentStyle = setPercentStyle;
            vm.method = methodList(); //找機會要把上面的設定移到這裡
            //
            //=====
            vm.data = dataInit();
            vm.view = viewInit();
            //======
            $scope.$watch('vm.isFocus', function(newValue) {
                if (newValue === true) {
                    logicInit();
                }
            });
            $scope.$watch('vm.data.repairProjectInFilter.length', function(newValue, oldValue) {
                if (newValue === oldValue) { return; }
                if (!newValue) { newValue = 0; }
                vm.view.courseEmpty = newValue < 1;
            });
        }

        function methodList() {
            var result = {};
            return result;
        }

        function dataInit() {
            var result = {
                timeConfig: {},
                sessionSelected: null,
                repairProject: [], //..........待修項目資料
                repairProjectInFilter: [], //..待修項目資料(查詢結果)
            };
            return result;
        }

        function viewInit() {
            var result = {
                courseEmpty: false, //.........查無資料判定
                isInited: false, //............是否被初始化過
                pageLoaded: false, //..........頁面讀取完畢
                pageLoading: false, //.........頁面讀取中
            };
            return result;
        }

        function logicInit() {
            vm.view.isInited = true;
            vm.view.pageLoaded = false;
            vm.view.pageLoading = true;
            //=====
            var promiseList = [
                loadConfig(),
                loadItemList()
            ];
            $q.all(promiseList)
                .then(function() {
                    vm.view.pageLoaded = true;
                    vm.view.pageLoading = false;
                });

        }

        function loadConfig() {
            return trainingInnerService.getConfigSetting()
                .then(function(configData) {
                    vm.data.timeConfig = configData.data;
                });
        }

        function loadItemList() {
            // console.log("repairProjec loadItemList");
            return trainingInnerService.loadLangs()
                .then(function(langs) {
                    var repairProject = [];
                    var promiseList = [];
                    //console.log('langs:', langs);
                    _.forEach(langs, function(lang) {
                        // console.log('lang:', lang.langCode)
                        // console.log( trainingInnerService.getUnfinishedActivities(lang.langCode))
                        promiseList.push(trainingInnerService.getUnfinishedActivities(lang.langCode));
                    });
                    return $q.all(promiseList).then(function(data) {
                        _.forEach(data, function(perReceiveData) {
                            // console.log('perReceiveData:',perReceiveData);
                            perReceiveData = _.orderBy(perReceiveData,   [ 'sessionTime'],   ['desc']);
                            Array.prototype.push.apply(repairProject, perReceiveData);
                        });
                        repairProject = _.uniqBy(repairProject, function(courseItem) {
                            //設定唯一鍵
                            return courseItem.sessionId;
                        });
                        //console.log('repairProject:',repairProject);
                        return repairProject;
                    });
                })
                .then(function(repairProject) {
                    //取代sessionTime中的<br>
                    _.forEach(repairProject, function(data) {
                        //console.log('sTime:',data.sessionTime);
                        data.sessionTime = data.sessionTime.replace(/\<br\>/ig, ' ');
                        //console.log('data:',data.sessionTime);
                    });
                    vm.data.repairProject = repairProject;
                    vm.view.courseEmpty = (repairProject.length < 1);
                    return true;
                });
        }

        function openDetail(item) {
            vm.data.sessionSelected = item.sessionId;
            //==========
            var param = {
                item: item,
                timeConfig: vm.data.timeConfig
            };
            var openModal = modalService.trainingSelectAction(param);

            openModal.result.then(function() {
                //關閉視窗時要重整頁面
                loadItemList();
            });
        }


        function setPercentStyle(item) {
            var progress;
            var percentage;
            var style = {};
            if (item.progress && item.progress.length > 0) {
                progress = item.progress.split('/');
                if (progress.length < 2) {
                    item.progress = null;
                    progress = ['0', '1'];
                }
            } else {
                item.progress = null;
                progress = ['0', '1'];
            }
            percentage = 100 * (parseFloat(progress[0]) / parseFloat(progress[1]));
            percentage = parseInt(percentage) + '';
            if (percentage === '0') {
                style = { 'display': 'none' };
            } else {
                style = { 'width': percentage + '%' };
            }
            return style;
        }

        function directToCourse() {
            //console.log("current url:", location.href);
            var menuNo = location.href.split('menu=')[1];
            //2023-07-10 Johnson 資安2023
            location.href = eval(function (p, a, c, k, e, r) { e = function (c) { return c.toString(a) }; if (!''.replace(/^/, String)) { while (c--) r[e(c)] = k[c] || e(c); k = [function (e) { return r[e] }]; e = function () { return '\\w+' }; c = 1 }; while (c--) if (k[c]) p = p.replace(new RegExp('\\b' + e(c) + '\\b', 'g'), k[c]); return p }('2.3.4(\'/#\')[0]+\'/#/5/6?7=\'+8.1(/</g,\'&9\').1(/>/g,\'&a\').1(/"/g,\'&b\').1(/\'/g,\'&#c\').1(/[<>!]|(\\(\\))|((d|e|f)\\h*\\(.*\\))/g,\'\')', 18, 18, '|replace|location|href|split|tsu|course|menu|menuNo|lt|gt|quot|x27|for|while|if||s'.split('|'), 0, {}))
        }
    }
})();